import { getAuthToken } from "../../services/authService-sighup";

export const getHeaders = async () => {
  const token = await getAuthToken(process.env.REACT_APP_MARKETDATA_SCOPE);

  if (!token) {
    throw new Error("Failed to retrieve authentication token for marketdata API.");
  }

  const subscriptionKey = (
    process.env.REACT_APP_SUBSCRIPTION_KEY_MARKETDATA ??
    process.env.REACT_APP_SUBSCRIPTION_KEY_TIMESERIES ??
    ""
  ).trim();
  const product = (process.env.REACT_APP_PRODUCT_APIM ?? "").trim();

  if (!subscriptionKey || !product) {
    throw new Error("Missing marketdata APIM header configuration in environment variables.");
  }

  return {
    Authorization: `Bearer ${token}`,
    "Ocp-Apim-Subscription-Key": subscriptionKey,
    Product: product,
    'X-Entitlement-Domain': 'amp',
    'X-Entitlement-Service': 'general_amp_service',
  };
};
